/**
 * `components.MuiMenu` — menu paper border styling.
 * Discoverability: `MuiMenu`, `Menu`, `MenuItem`, `paper`.
 *
 * @see https://mui.com/material-ui/api/menu/
 *
 */
import type { Components, Theme } from '@mui/material/styles';

export function muiMenu(theme: Theme): Pick<Components<Theme>, 'MuiMenu'> {
  const { palette } = theme;
  return {
    MuiMenu: {
      styleOverrides: {
        paper: {
          border: `1px solid ${palette.border.light}`,
        },
      },
    },
  };
}
